module.exports = __webpack_public_path__ + "img/dropdown.08ddcf2f.jpg";